import resumeEditor from './pc/resumeEditor.vue'
import RootLayout from '@/views/admin/layout/rootLayout.vue'
import '@/assets/scss/adaptWrapper.scss'

const basePath = '/recruiting/personal'

export default {
  name: 'personalResume',
  path: `${basePath}`,
  component: RootLayout,
  meta: {
    isInclude: false,
    mobileHomeMenu: {
      redirectPath: '/mobile-web-mini-resume/',
      iconClass: 'iconresume',
      nameI18nKey: 'personal.resume.homeMenu.name',
      descI18nKey: 'personal.resume.homeMenu.desc'
    },
    rootLayout: {
      hiddenBackgroundImage: true,
      hiddenTabList: true,
      flexMode: true
    }
  },
  children: [
    {
      name: 'personalResumeAdd',
      path: `${basePath}/resume/add`,
      component: resumeEditor,
      meta: {
        isEditMode: false,
        isMiniResume: false,
        titleI18nKey: 'personal.resume.tabTitle.resumeAdd',
        personalLayout: {
          blankPage: true
        }
      }
    },
    {
      name: 'personalResumeEdit',
      path: `${basePath}/resume/edit`,
      component: resumeEditor,
      meta: {
        isEditMode: true,
        isMiniResume: false,
        titleI18nKey: 'personal.resume.tabTitle.resumeEdit',
        personalLayout: {
          blankPage: true
        }
      }
    },
    {
      name: 'personalMiniResumeAdd',
      path: `${basePath}/mini-resume/add`,
      component: resumeEditor,
      meta: {
        isEditMode: false,
        isMiniResume: true,
        titleI18nKey: 'personal.resume.tabTitle.resumeEdit',
        personalLayout: {
          blankPage: true
        }
      }
    },
    {
      name: 'personalMiniResumeEdit',
      path: `${basePath}/mini-resume/edit`,
      component: resumeEditor,
      meta: {
        isEditMode: true,
        isMiniResume: true,
        titleI18nKey: 'personal.resume.tabTitle.resumeEdit',
        personalLayout: {
          blankPage: true
        }
      }
    }
  ]
}
